module.exports = "/_next/static/images/aerialConstruction-85a703d79b1aca20793b71d0ed390405.webp";